import React, { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import API_URL from '../config/api';
import { 
  FiUpload, 
  FiUser, 
  FiLock, 
  FiCalendar, 
  FiMapPin, 
  FiBriefcase,
  FiHash,
  FiCheckCircle,
  FiClock,
  FiZap,
  FiDownload
} from 'react-icons/fi';

const ImportClients = () => {
  const [loading, setLoading] = useState(false);
  const [importResult, setImportResult] = useState(null);
  const [activeTab, setActiveTab] = useState('form');
  
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    address: '',
    company: '',
    username: '',
    password: '',
    accountNumber: '',
    startDate: '',
    dueDate: '',
    powerStatus: 'activo'
  });

  const [formErrors, setFormErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: ''
      });
    }
  };

  const validateForm = () => {
    const errors = {};
    
    if (!formData.firstName.trim()) errors.firstName = 'El nombre es requerido';
    if (!formData.lastName.trim()) errors.lastName = 'El apellido es requerido';
    if (!formData.address.trim()) errors.address = 'La dirección es requerida';
    if (!formData.company.trim()) errors.company = 'La compañía es requerida';
    if (!formData.username.trim()) errors.username = 'El usuario es requerido';
    if (!formData.password.trim()) errors.password = 'La contraseña es requerida';
    if (!formData.accountNumber.trim()) errors.accountNumber = 'El número de cuenta es requerido';
    if (!formData.startDate) errors.startDate = 'La fecha de inicio es requerida';
    if (!formData.dueDate) errors.dueDate = 'La fecha de vencimiento es requerida';
    
    if (formData.startDate && formData.dueDate) {
      const start = new Date(formData.startDate);
      const due = new Date(formData.dueDate);
      if (due <= start) {
        errors.dueDate = 'La fecha de vencimiento debe ser posterior a la fecha de inicio';
      }
    }
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

 const handleSubmitForm = async (e) => {
  e.preventDefault();
  
  if (!validateForm()) {
    toast.error('Por favor completa todos los campos requeridos');
    return;
  }

  setLoading(true);
  
  try {
    const token = localStorage.getItem('token');
    
    // Crear el pipe con SOLO los 10 campos del formulario
    const pipeLine = [
      formData.firstName,                          // 0: Nombre
      formData.lastName,                           // 1: Apellido
      formData.address,                            // 2: Dirección
      formData.company,                            // 3: Compañía
      formData.username,                           // 4: Usuario
      formData.password,                           // 5: Contraseña
      formData.accountNumber,                      // 6: Account Number
      formData.startDate,                          // 7: Fecha inicio
      formData.dueDate,                            // 8: Fecha vencimiento
      formData.powerStatus                         // 9: Estado de luz
    ].join('|');

    console.log('📤 Enviando datos en formato pipe (10 campos):', pipeLine);
    console.log('📊 Total de campos:', pipeLine.split('|').length); // Deberían ser 10

    const response = await axios.post(
      `${API_URL}/api/clients/import`,
      { text: pipeLine, format: 'pipe' },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    console.log('✅ Respuesta:', response.data);
    setImportResult(response.data);

    if (response.data.imported > 0) {
      toast.success(`✅ Cliente importado correctamente`);
      setFormData({
        firstName: '',
        lastName: '',
        address: '',
        company: '',
        username: '',
        password: '',
        accountNumber: '',
        startDate: '',
        dueDate: '',
        powerStatus: 'activo'
      });
    }

    if (response.data.errors?.length > 0) {
      toast.error(`❌ ${response.data.errors[0]}`);
    }
  } catch (error) {
    console.error('❌ Error:', error);
    toast.error(error.response?.data?.message || 'Error al importar cliente');
  } finally {
    setLoading(false);
  }
};

  // ✅ FUNCIÓN PARA IMPORTAR EXCEL (AHORA DEFINIDA)
  const handleFileImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_URL}/api/clients/import-excel`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      setImportResult(response.data);
      toast.success(`✅ ${response.data.imported} clientes importados`);
    } catch (error) {
      console.error('❌ Error:', error);
      toast.error(error.response?.data?.message || 'Error al importar archivo');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-4 md:p-6">
      <h1 className="text-2xl md:text-3xl font-bold mb-2">Flex Energy</h1>
      <p className="text-gray-600 mb-6">Importar Clientes</p>

      <div className="bg-white rounded-lg shadow">
        <div className="border-b flex">
          <button
            onClick={() => setActiveTab('form')}
            className={`flex-1 px-4 py-3 text-sm font-medium ${
              activeTab === 'form'
                ? 'border-b-2 border-blue-600 text-blue-600'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            <FiUser className="inline mr-2" />
            Formulario Individual
          </button>
          <button
            onClick={() => setActiveTab('excel')}
            className={`flex-1 px-4 py-3 text-sm font-medium ${
              activeTab === 'excel'
                ? 'border-b-2 border-blue-600 text-blue-600'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            <FiUpload className="inline mr-2" />
            Excel / CSV
          </button>
        </div>

        <div className="p-6">
          {activeTab === 'form' && (
            <form onSubmit={handleSubmitForm} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Nombre */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <FiUser className="inline mr-2" />
                    Nombre *
                  </label>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    className={`w-full px-4 py-2 border rounded-lg ${
                      formErrors.firstName ? 'border-red-500' : 'border-gray-300'
                    }`}
                  />
                  {formErrors.firstName && (
                    <p className="mt-1 text-xs text-red-600">{formErrors.firstName}</p>
                  )}
                </div>

                {/* Apellido */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <FiUser className="inline mr-2" />
                    Apellido *
                  </label>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    className={`w-full px-4 py-2 border rounded-lg ${
                      formErrors.lastName ? 'border-red-500' : 'border-gray-300'
                    }`}
                  />
                  {formErrors.lastName && (
                    <p className="mt-1 text-xs text-red-600">{formErrors.lastName}</p>
                  )}
                </div>

                {/* Dirección */}
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <FiMapPin className="inline mr-2" />
                    Dirección *
                  </label>
                  <input
                    type="text"
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    className={`w-full px-4 py-2 border rounded-lg ${
                      formErrors.address ? 'border-red-500' : 'border-gray-300'
                    }`}
                  />
                  {formErrors.address && (
                    <p className="mt-1 text-xs text-red-600">{formErrors.address}</p>
                  )}
                </div>

                {/* Compañía */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <FiBriefcase className="inline mr-2" />
                    Compañía *
                  </label>
                  <input
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleInputChange}
                    className={`w-full px-4 py-2 border rounded-lg ${
                      formErrors.company ? 'border-red-500' : 'border-gray-300'
                    }`}
                  />
                  {formErrors.company && (
                    <p className="mt-1 text-xs text-red-600">{formErrors.company}</p>
                  )}
                </div>

                {/* Usuario */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <FiUser className="inline mr-2" />
                    Usuario *
                  </label>
                  <input
                    type="text"
                    name="username"
                    value={formData.username}
                    onChange={handleInputChange}
                    className={`w-full px-4 py-2 border rounded-lg ${
                      formErrors.username ? 'border-red-500' : 'border-gray-300'
                    }`}
                  />
                  {formErrors.username && (
                    <p className="mt-1 text-xs text-red-600">{formErrors.username}</p>
                  )}
                </div>

                {/* Contraseña */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <FiLock className="inline mr-2" />
                    Contraseña *
                  </label>
                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    className={`w-full px-4 py-2 border rounded-lg ${
                      formErrors.password ? 'border-red-500' : 'border-gray-300'
                    }`}
                  />
                  {formErrors.password && (
                    <p className="mt-1 text-xs text-red-600">{formErrors.password}</p>
                  )}
                </div>

                {/* Account Number */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <FiHash className="inline mr-2" />
                    Account Number *
                  </label>
                  <input
                    type="text"
                    name="accountNumber"
                    value={formData.accountNumber}
                    onChange={handleInputChange}
                    className={`w-full px-4 py-2 border rounded-lg ${
                      formErrors.accountNumber ? 'border-red-500' : 'border-gray-300'
                    }`}
                  />
                  {formErrors.accountNumber && (
                    <p className="mt-1 text-xs text-red-600">{formErrors.accountNumber}</p>
                  )}
                </div>

                {/* Fecha inicio */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <FiCalendar className="inline mr-2" />
                    Fecha inicio *
                  </label>
                  <input
                    type="date"
                    name="startDate"
                    value={formData.startDate}
                    onChange={handleInputChange}
                    className={`w-full px-4 py-2 border rounded-lg ${
                      formErrors.startDate ? 'border-red-500' : 'border-gray-300'
                    }`}
                  />
                  {formErrors.startDate && (
                    <p className="mt-1 text-xs text-red-600">{formErrors.startDate}</p>
                  )}
                </div>

                {/* Fecha vencimiento */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <FiCalendar className="inline mr-2" />
                    Fecha vencimiento *
                  </label>
                  <input
                    type="date"
                    name="dueDate"
                    value={formData.dueDate}
                    onChange={handleInputChange}
                    className={`w-full px-4 py-2 border rounded-lg ${
                      formErrors.dueDate ? 'border-red-500' : 'border-gray-300'
                    }`}
                  />
                  {formErrors.dueDate && (
                    <p className="mt-1 text-xs text-red-600">{formErrors.dueDate}</p>
                  )}
                </div>

                {/* Estado de luz */}
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-3">
                    <FiZap className="inline mr-2" />
                    Estado de la Luz *
                  </label>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <label className={`flex items-center p-4 border rounded-lg cursor-pointer ${
                      formData.powerStatus === 'activo' 
                        ? 'border-green-500 bg-green-50' 
                        : 'border-gray-200'
                    }`}>
                      <input
                        type="radio"
                        name="powerStatus"
                        value="activo"
                        checked={formData.powerStatus === 'activo'}
                        onChange={handleInputChange}
                        className="sr-only"
                      />
                      <FiCheckCircle className="text-green-500 mr-3" size={24} />
                      <div>
                        <p className="font-medium">Activa</p>
                        <p className="text-xs text-gray-500">✅ Servicio normal</p>
                      </div>
                    </label>

                    <label className={`flex items-center p-4 border rounded-lg cursor-pointer ${
                      formData.powerStatus === 'espera' 
                        ? 'border-yellow-500 bg-yellow-50' 
                        : 'border-gray-200'
                    }`}>
                      <input
                        type="radio"
                        name="powerStatus"
                        value="espera"
                        checked={formData.powerStatus === 'espera'}
                        onChange={handleInputChange}
                        className="sr-only"
                      />
                      <FiClock className="text-yellow-500 mr-3" size={24} />
                      <div>
                        <p className="font-medium">En Espera</p>
                        <p className="text-xs text-gray-500">⏰ Pendiente</p>
                      </div>
                    </label>

                    <label className={`flex items-center p-4 border rounded-lg cursor-pointer ${
                      formData.powerStatus === 'desconectado' 
                        ? 'border-red-500 bg-red-50' 
                        : 'border-gray-200'
                    }`}>
                      <input
                        type="radio"
                        name="powerStatus"
                        value="desconectado"
                        checked={formData.powerStatus === 'desconectado'}
                        onChange={handleInputChange}
                        className="sr-only"
                      />
                      <FiZap className="text-red-500 mr-3" size={24} />
                      <div>
                        <p className="font-medium">Desconectada</p>
                        <p className="text-xs text-gray-500">⚡ Suspendido</p>
                      </div>
                    </label>
                  </div>
                </div>
              </div>

              <div className="flex justify-end gap-3 pt-4 border-t">
                <button
                  type="button"
                  onClick={() => {
                    setFormData({
                      firstName: '',
                      lastName: '',
                      address: '',
                      company: '',
                      username: '',
                      password: '',
                      accountNumber: '',
                      startDate: '',
                      dueDate: '',
                      powerStatus: 'activo'
                    });
                    setFormErrors({});
                  }}
                  className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                >
                  Limpiar
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="flex items-center px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
                >
                  <FiUpload className="mr-2" />
                  {loading ? 'Importando...' : 'Importar Cliente'}
                </button>
              </div>
            </form>
          )}

          {activeTab === 'excel' && (
            <div className="py-4">
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
                <FiUpload className="mx-auto text-4xl text-gray-400 mb-4" />
                <p className="text-gray-600 mb-2">Arrastra tu archivo Excel aquí o</p>
                <input
                  type="file"
                  accept=".xlsx,.xls,.csv"
                  onChange={handleFileImport}
                  className="hidden"
                  id="file-upload"
                  disabled={loading}
                />
                <label
                  htmlFor="file-upload"
                  className="inline-block px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 cursor-pointer"
                >
                  Seleccionar archivo
                </label>
                <p className="text-xs text-gray-500 mt-2">
                  Formatos aceptados: .xlsx, .xls, .csv
                </p>
              </div>
            </div>
          )}

          {importResult && (
            <div className="mt-6 border-t pt-6">
              <h3 className="text-lg font-semibold mb-4">Resultado de Importación</h3>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                <div className="bg-green-50 p-4 rounded-lg">
                  <p className="text-sm text-green-600">Importados</p>
                  <p className="text-2xl font-bold text-green-700">{importResult.imported}</p>
                </div>
                <div className="bg-red-50 p-4 rounded-lg">
                  <p className="text-sm text-red-600">Errores</p>
                  <p className="text-2xl font-bold text-red-700">{importResult.errors?.length || 0}</p>
                </div>
                <div className="bg-blue-50 p-4 rounded-lg">
                  <p className="text-sm text-blue-600">Total</p>
                  <p className="text-2xl font-bold text-blue-700">{importResult.totalProcessed || importResult.imported}</p>
                </div>
              </div>

              {importResult.clients?.length > 0 && (
                <div className="mt-4">
                  <h4 className="font-medium mb-2">Clientes importados:</h4>
                  <div className="bg-gray-50 rounded-lg p-4 max-h-60 overflow-y-auto">
                    {importResult.clients.map((client, idx) => (
                      <div key={idx} className="text-sm py-1 border-b last:border-0">
                        #{client.clientNumber} - {client.fullName} - {client.company}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {importResult.errors?.length > 0 && (
                <div className="mt-4">
                  <h4 className="font-medium text-red-600 mb-2">Errores:</h4>
                  <div className="bg-red-50 rounded-lg p-4 max-h-40 overflow-y-auto">
                    {importResult.errors.map((error, idx) => (
                      <div key={idx} className="text-sm text-red-600 py-1">
                        • {error}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImportClients;